import { FC, useState } from 'react';

import { TogglePill } from '@base-app';
import { SectionHeaderProps } from './SectionHeader.types';
import { StyledSectionHeader } from './SectionHeader.styles';

const SectionHeader: FC<SectionHeaderProps> = ({ handleTogglePills, pillId, pillOptions }) => {
  const [, setSelectedPill] = useState<string>(pillId);

  const onClickPill = (id: string): void => {
    handleTogglePills?.(id);
    setSelectedPill(id);
  };

  return (
    <StyledSectionHeader>
      <TogglePill defaultSelectedPill={pillId} handleTogglePillChange={onClickPill} options={pillOptions} />
    </StyledSectionHeader>
  );
};

export default SectionHeader;
